import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create, StoreApi, UseBoundStore } from 'zustand';

interface ModuleVersionsState {
    moduleVersions: Record<string, string>;
    setModuleVersions: (versions: Record<string, string>) => void;
    getModuleVersion: (packageName: string) => string;
}

let storeInstance: UseBoundStore<StoreApi<ModuleVersionsState>> | null = null;

const createStore = () =>
    create<ModuleVersionsState>()((set, get) => ({
        moduleVersions: {},
        setModuleVersions: (versions) => set({ moduleVersions: versions }),
        getModuleVersion: (packageName) => {
            const versions = get().moduleVersions;
            return versions[packageName] || '';
        },
    }));

const useModuleVersionStore = (() => {
    if (!storeInstance) {
        storeInstance = createStore();
    }
    return createSelectorHooks(storeInstance);
})();

export { useModuleVersionStore };
